import {inject, Injectable, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';

@Injectable({ providedIn: 'root' })
export class RouterExtService {
  private readonly router: Router = inject(Router);
  private previousUrl?: string;
  private currentUrl?: string;

  constructor() {
    this.currentUrl = this.router.url;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      }
    });
  }

  public getPreviousUrl() {
    if(this.previousUrl === this.currentUrl) {
      return undefined;
    }
    return this.previousUrl;
  }
}
